<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                cols="12"
                md="6"
            >
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-form
                                ref="dayBatchForm"
                                v-model="isValid"
                            >
                                <v-card-title>
                                    Day Batch #{{
                                    dayBatch.dayBatchNumber
                                    }}
                                </v-card-title>
                                <v-card-text>
                                    <v-container
                                        class="pa-0"
                                        fluid
                                    >
                                        <v-row class="pb-0">
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                <v-file-input
                                                    :disabled="isLoading"
                                                    accept="image/png, image/jpeg, image/bmp, application/pdf"
                                                    label="Returned Cover"
                                                    placeholder="Set Returned Cover Document"
                                                    v-model="
                                                        returnedCoverDocument
                                                    "
                                                >
                                                    <template slot="append-outer">
                                                        <v-btn
                                                            @click.stop="
                                                                getReturnedCoverFile
                                                            "
                                                            elevation="1"
                                                            fab
                                                            small
                                                            v-show="
                                                                dayBatch.returnedCoverFileId >
                                                                0
                                                            "
                                                        >
                                                            <h3>
                                                                <v-icon color="light-blue">mdi-download</v-icon>
                                                            </h3>
                                                        </v-btn>
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            align="end"
                                            class="pt-5"
                                            justify="space-between"
                                            no-gutters
                                        >
                                            <v-btn
                                                :disabled="
                                                    isLoading && !isDeleting
                                                "
                                                :loading="isDeleting"
                                                @click="deleteEntity"
                                                class="text-none"
                                                color="warning darken-1"
                                                text
                                                v-show="dayBatch.id > 0"
                                            >Delete</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                :disabled="isLoading"
                                                @click="closeForm"
                                                class="text-none"
                                                color="secondary darken-1"
                                                text
                                            >Close</v-btn>
                                            <v-btn
                                                :disabled="
                                                    isLoading && !isSaving
                                                "
                                                :loading="isSaving"
                                                @click="saveEntity"
                                                class="text-none"
                                                color="secondary darken-1"
                                                text
                                            >Update</v-btn>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
                <v-row>
                    <v-col cols="12">
                        <v-btn
                            @click="showMultiSearch = !showMultiSearch"
                            color="secondary darken-1"
                            icon
                        >
                            <v-icon v-if="anyMultiSearchInput">mdi-card-search</v-icon>
                            <v-icon v-else>mdi-card-search-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    :key="claim.id"
                    v-for="(claim,index) in dayBatch.claims"
                    v-show="filterClaim(claim)"
                >
                    <v-col cols="12">
                        <ClaimPostSubmissionForm
                            :claim-in="claim"
                            :identity-types="identityTypes"
                            :key="reloadKey + index"
                            :providers="providers"
                            @saved="emitSavedEntity"
                            @notify="notify"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-show="populating == true">
            <v-col
                class="text-center"
                cols="12"
            >
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                class="text-center"
                cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
        </v-row>
        <!--MultiSeardch SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            v-model="showMultiSearch"
            width="350px"
        >
            <multi-search-input-form
                :fields="multiSearchValues"
                @close="showMultiSearch = false"
                @reset="multiSearch"
                @search="multiSearch"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import ClaimPostSubmissionForm from "./ClaimPostSubmissionForm";
import MultiSearchInputForm from "./MultiSearchInputForm.vue";
import uuid4 from "../../helpers/uuid4";
export default {
    props: {
        dayBatchIn: Number,
        dayBatchNumber: String,
        multiSearchIn: Array
    },
    created: async function() {
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.providers = await this.$store.dispatch("providers/getlist");
    },
    components: {
        ClaimPostSubmissionForm,
        MultiSearchInputForm
    },
    data() {
        return {
            populating: true,
            populatingFailure: true,
            dayBatch: {}, //new DayBatch(), // new DayBatch().set(this.dayBatchIn),
            returnedCoverDocument: null,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isGeneratingCoverPage: null,
            requestId: uuid4(),
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            numericReg: /^\d+$/,
            isNumber: n => this.numericReg.test(n) || "not a whole number",

            identityTypes: [],
            provider: [],

            showMultiSearch: false,
            multiSearchValues: this.multiSearchIn,
            reloadKey: 0
        };
    },
    mounted: async function() {
        await this.loadDayBatch();
        this.multiSearchValues = this.multiSearchIn
            .filter(
                x =>
                    x.property != "dayBatchNumber" &&
                    x.property != "providerName"
            )
            .map(function(x) {
                return {
                    display: x.display,
                    property: x.property,
                    value: x.value
                };
            });
    },
    computed: {
        anyMultiSearchInput: function() {
            return this.multiSearchValues.some(
                x => x.value != "" && x.value != null
            );
        }
        //
    },
    methods: {
        async loadDayBatch() {
            if (
                this.dayBatchIn > 0 &&
                this.dayBatchNumber != null &&
                this.dayBatchNumber != ""
            ) {
                var requestId = (this.requestId = uuid4());
                var dayBatchesResponse = await this.$store.dispatch(
                    "dayBatches/getDayBatchPostSubmissionFormDto",
                    {
                        id: this.dayBatchIn,
                        requestId: requestId
                    }
                );
                if (
                    this.requestId == dayBatchesResponse.requestId &&
                    dayBatchesResponse.data != null &&
                    dayBatchesResponse.data.dayBatchNumber ==
                        this.dayBatchNumber &&
                    dayBatchesResponse.data.id == this.dayBatchIn
                ) {
                    this.dayBatch = dayBatchesResponse.data;
                    this.reloadKey += 1000;

                    this.populatingFailure = false;
                }
            }
            this.populating = false;
        },
        filterClaim(claim) {
            var filters = this.multiSearchValues.filter(
                x => x.value != "" && x.value != null
            );
            if (filters.length == 0) return true;
            else {
                return filters.some(x => {
                    var matched = false;
                    switch (x.property) {
                        case "claimId":
                            matched = claim.id.toString() == x.value;
                            break;
                        case "linkNumber":
                            matched =
                                (claim.linkNumber ?? "").toLowerCase() ==
                                x.value.toLowerCase();
                            break;
                        case "accountId":
                            matched = claim.accounts.some(
                                y => y.id.toString() == x.value
                            );
                            break;
                        case "grvNumber":
                            matched = claim.accounts.some(
                                y =>
                                    (y.grvNumber ?? "").toLowerCase() ==
                                    x.value.toLowerCase()
                            );
                            break;
                        case "invoiceNumber":
                            matched = claim.accounts.some(
                                y =>
                                    (y.invoiceNumber ?? "").toLowerCase() ==
                                    x.value.toLowerCase()
                            );
                            break;
                        case "patientName":
                            matched = (claim.patient.name ?? "")
                                .toLowerCase()
                                .includes(x.value.toLowerCase());
                            break;
                        case "patientSurname":
                            matched = (claim.patient.surname ?? "")
                                .toLowerCase()
                                .includes(x.value.toLowerCase());
                            break;
                        case "patientIdentityNumber":
                            matched = (claim.patient.identificationNumber ?? "")
                                .toLowerCase()
                                .includes(x.value.toLowerCase());
                            break;
                    }
                    return matched;
                });
            }
        },
        multiSearch(values) {
            this.multiSearchValues = values;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        getReturnedCoverFile() {
            this.getFile(
                this.dayBatch.returnedCoverFileId,
                "daybatch#" +
                    this.dayBatch.id +
                    "returnedCover" +
                    this.dayBatch.returnedCoverFileId
            );
        },

        //emitters      ------------------------------------------------------------
        emitSavedEntity() {
            this.$emit("saved");
        },
        emitDeletedEntity(deletedDayBatch) {
            this.$emit("deleted", deletedDayBatch);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.$emit("notify", message, color);
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.dayBatchForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append(
                    "ReturnedCoverFile",
                    this.returnedCoverDocument
                );
                formdata.append("DayBatchId", this.dayBatch.id);

                const parameters = {
                    id: this.dayBatch.id,
                    formData: formdata
                };
                try {
                    await this.$store.dispatch(
                        "dayBatches/setreturnedcoverdocument",
                        parameters
                    );
                    await this.loadDayBatch();
                    this.notify("Daybatch successfully saved.", "success");
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.emitSavedEntity();
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this Day Batch?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("dayBatches/delete", this.dayBatch.id)
                    .then(
                        () => {
                            this.notify(
                                "Day Batch successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.dayBatch);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>